export default __webpack_public_path__ + "static/media/icon_youtube.460ca599.svg";